import Container from '@mui/material/Container'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import { useTranslation } from 'react-i18next'
import RaceGuide from './DetailsComponents/RaceGuide/RaceGuide'
// import L1SRunnerGuide from '../../RacesGuides/Last1Standing/Last1StandingWrapper'

export default function Details ({ eventDetails, category, item }) {
  const { t } = useTranslation('race')
  if (!eventDetails?.showDetails) {
    return <span />
  }
  return (
    <Container maxWidth='xl'>
      {/* <L1SRunnerGuide /> */}
      {/* {eventDetails?.slug === 'last-one-standing' */}
      {/* ? <LastOneStanding race={eventDetails} /> */}
      {/* : <RaceGuide race={eventDetails} {...{ category, item }} />} */}
      <RaceGuide race={eventDetails} {...{ category, item }} />

      {eventDetails?.description && (
        <Typography
          sx={{
            whiteSpace: 'pre-line',
            mt: 6,
            fontSize: { xs: '1rem', md: '1.1rem' },
            lineHeight: 1.8
          }}
        >
          {eventDetails.description}
        </Typography>
      )}

      <Box
        sx={{
          display: 'flex',
          gap: 6,
          alignItems: 'flex-start',
          mt: 6
        }}
      >
        <Box>
          <Typography
            variant='h6' gutterBottom sx={{
            fontWeight: 'bold'
          }}
          >
            {t('details.subscribe')}
          </Typography>
          <Button
            variant='outlined'
            color='primary'
            sx={{ my: 3, color: 'white' }}
            startIcon={<WhatsAppIcon />}
            onClick={() => window.open('https://chat.whatsapp.com/HQ4mM6YgqKZ2bR4B9iaJmz', '_blank')}
          >
            {t('details.joinWhatsAppGroup')}
          </Button>
        </Box>
        {/* <Box component='img' src='https://d1hi0tbu2kom2c.cloudfront.net/assets/races-group.png' sx={{ width: 120 }} /> */}
      </Box>
    </Container>
  )
}
